import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import { AnimatePresence } from "framer-motion";
import Modal from "../../components/Modal";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/34364c86-6326-43df-957a-cbbe3e1506a0" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_gallery.field_media_image,field_gallery1.field_media_image," +
  "field_imagen5.field_media_image," +
  "field_imagen6.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_gallery,field_gallery1,field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30,field_bloque31,field_bloque32,field_bloque33,field_bloque34," +
  "field_imagen5,field_imagen6,field_imagen13,field_imagen14,field_imagen15" +
  "&fields[media--image]=field_media_image";

export default function Gobernanza() {
  const processContent = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");

      if (src && !src.startsWith("http")) {
        img.setAttribute(
          "src",
          `https://portales.utpl.edu.ec/beportales/${src.replace(/^\/+/, "")}`,
        );
      }
    });

    return doc.body.innerHTML;
  };

  const DataDisplay = ({ data }) => (
    <div>
      <div
        className="mt-24 text-center max-w-6xl m-auto   sm:px-0"
        dangerouslySetInnerHTML={{
          __html: data.texto_portada,
        }}
      />
      {/*CONSEJO SUPERIOR */}
      <section>
        <div
          className="text-center max-w-6xl m-auto px-6 sm:px-0  "
          dangerouslySetInnerHTML={{
            __html: data.bloque1,
          }}
        />
        <div>
          <div className="max-w-6xl mx-auto px-6 sm:px-0 pb-10">
            {/* Renderizado de Bloque Dinámico */}
            <div
              className="
    grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8
    
    /* ESTILOS DE CARD PARA CADA DIV HIJO */
    [&>div]:bg-white 
    [&>div]:rounded-2xl 
    [&>div]:p-6 
    [&>div]:shadow-md 
    [&>div]:border 
    [&>div]:border-gray-100 
    [&>div]:transition-all 
    [&>div]:duration-300 
    [&>div]:flex 
    [&>div]:flex-col 
    [&>div]:items-center 
    [&>div]:text-center
    [&>div]:relative
    [&>div]:overflow-hidden
    
    /* ESTILOS DE IMAGEN DENTRO DE LA CARD */
 
    [&>div_img]:object-cover 
   
    [&>div_img]:mb-4 
    [&>div_img]:ring-4 
    [&>div_img]:ring-amber-300
    [&>div_img]:shadow-sm
    
  "
              dangerouslySetInnerHTML={{
                __html: processContent(data.bloque2),
              }}
            />
          </div>
        </div>
      </section>
      {/*CONSEJO TUTELAR */}
      <section>
        <div
          className="text-center max-w-6xl m-auto px-6 sm:px-0 pt-10"
          dangerouslySetInnerHTML={{
            __html: data.bloque3,
          }}
        />

        <div className="max-w-6xl mx-auto px-6 sm:px-0 pb-10">
          {/* Renderizado de Bloque Dinámico */}
          <div
            className="
    grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8
    
    /* ESTILOS DE CARD PARA CADA DIV HIJO */
    [&>div]:bg-white 
    [&>div]:rounded-2xl 
    [&>div]:p-6 
    [&>div]:shadow-md 
    [&>div]:border 
    [&>div]:border-gray-100 
    [&>div]:transition-all 
    [&>div]:duration-300 
    [&>div]:flex 
    [&>div]:flex-col 
    [&>div]:items-center 
    [&>div]:text-center
    [&>div]:relative
    [&>div]:overflow-hidden
    
    /* ESTILOS DE IMAGEN DENTRO DE LA CARD */
 
    [&>div_img]:object-cover 
   
    [&>div_img]:mb-4 
    [&>div_img]:ring-4 
    [&>div_img]:ring-amber-300
    [&>div_img]:shadow-sm
    
  "
            dangerouslySetInnerHTML={{
              __html: processContent(data.bloque4),
            }}
          />
        </div>
      </section>
      {/*COGOBIERNO */}
      <section>
        <div
          className="link-1 text-center max-w-6xl m-auto px-6 sm:px-0 pt-10"
          dangerouslySetInnerHTML={{
            __html: data.bloque5,
          }}
        />

        <div className="max-w-6xl mx-auto px-6 sm:px-0 pb-10">
          <div
            className="
    grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8
    
    /* ESTILOS DE CARD PARA CADA DIV HIJO */
    [&>div]:bg-white 
    [&>div]:rounded-2xl 
    [&>div]:p-6 
    [&>div]:shadow-md 
    [&>div]:border 
    [&>div]:border-gray-100 
    [&>div]:transition-all 
    [&>div]:duration-300 
    [&>div]:flex 
    [&>div]:flex-col 
    [&>div]:items-center 
    [&>div]:text-center
    [&>div]:relative
    [&>div]:overflow-hidden
    
    /* ESTILOS DE IMAGEN DENTRO DE LA CARD */
 
    [&>div_img]:object-cover 
   
    [&>div_img]:mb-4 
    [&>div_img]:ring-4 
    [&>div_img]:ring-amber-300
    [&>div_img]:shadow-sm
    
  "
            dangerouslySetInnerHTML={{
              __html: processContent(data.bloque6),
            }}
          />
        </div>
      </section>
      {/*AUTORIDADES EJECUTIVAS */}
      <section className="bg-slate-50">
        <div
          className="text-center max-w-6xl m-auto px-6 sm:px-0 pt-10"
          dangerouslySetInnerHTML={{
            __html: data.bloque7,
          }}
        />
        {/*Vicerrectorado Académico */}
        <section>
          <div
            className="text-center max-w-6xl m-auto px-6 sm:px-0 "
            dangerouslySetInnerHTML={{
              __html: data.bloque8,
            }}
          />

          <div className="max-w-6xl mx-auto px-6 sm:px-0 pb-10">
            <div
              className="
    grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8
    
    /* ESTILOS DE CARD PARA CADA DIV HIJO */
    [&>div]:bg-white 
    [&>div]:rounded-2xl 
    [&>div]:p-4 
    [&>div]:shadow-md 
    [&>div]:border 
    [&>div]:border-gray-100 
    [&>div]:transition-all 
    [&>div]:duration-300 
    [&>div]:flex 
    [&>div]:flex-col 
    [&>div]:items-center 
    [&>div]:text-center
    [&>div]:relative
    [&>div]:overflow-hidden    
    /* ESTILOS DE IMAGEN DENTRO DE LA CARD */
    [&>div_img]:object-cover 
      [&>div_img]:w-24   
       [&>div_img]:h-24
        [&>div_img]:mb-6
    [&>div_img]:shadow-sm
      [&_p]:text-sm
        [&_p]:leading-base
           [&_p]:p-0
    
  "
              dangerouslySetInnerHTML={{
                __html: processContent(data.bloque9),
              }}
            />
          </div>
        </section>
        {/*Vicerrectorado de Investigación */}
        <div>
          <div
            className="text-center max-w-6xl m-auto px-6 sm:px-0 "
            dangerouslySetInnerHTML={{
              __html: data.bloque10,
            }}
          />
          <div className="max-w-6xl mx-auto px-6 sm:px-0 pb-10">
            {/* Renderizado de Bloque Dinámico */}
            <div
              className="
    grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8
    
    /* ESTILOS DE CARD PARA CADA DIV HIJO */
    [&>div]:bg-white 
    [&>div]:rounded-2xl 
    [&>div]:p-4 
    [&>div]:shadow-md 
    [&>div]:border 
    [&>div]:border-gray-100 
    [&>div]:transition-all 
    [&>div]:duration-300 
    [&>div]:flex 
    [&>div]:flex-col 
    [&>div]:items-center 
    [&>div]:text-center
    [&>div]:relative
    [&>div]:overflow-hidden    
    /* ESTILOS DE IMAGEN DENTRO DE LA CARD */
    [&>div_img]:object-cover 
      [&>div_img]:w-24   
       [&>div_img]:h-24
        [&>div_img]:mb-6
    [&>div_img]:shadow-sm
      [&_p]:text-sm
        [&_p]:leading-base
           [&_p]:p-0
    
  "
              dangerouslySetInnerHTML={{
                __html: processContent(data.bloque11),
              }}
            />
          </div>
        </div>
        {/*Vicerrectorado Administrativo */}
        <div>
          <div
            className="text-center max-w-6xl m-auto px-6 sm:px-0 "
            dangerouslySetInnerHTML={{
              __html: data.bloque12,
            }}
          />
          <div className="max-w-6xl mx-auto px-6 sm:px-0 pb-10">
            <div
              className="
    grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8
    
    /* ESTILOS DE CARD PARA CADA DIV HIJO */
    [&>div]:bg-white 
    [&>div]:rounded-2xl 
    [&>div]:p-4 
    [&>div]:shadow-md 
    [&>div]:border 
    [&>div]:border-gray-100 
    [&>div]:transition-all 
    [&>div]:duration-300 
    [&>div]:flex 
    [&>div]:flex-col 
    [&>div]:items-center 
    [&>div]:text-center
    [&>div]:relative
    [&>div]:overflow-hidden    
    /* ESTILOS DE IMAGEN DENTRO DE LA CARD */
    [&>div_img]:object-cover 
      [&>div_img]:w-24   
       [&>div_img]:h-24
        [&>div_img]:mb-6
    [&>div_img]:shadow-sm
      [&_p]:text-sm
        [&_p]:leading-base
           [&_p]:p-0
    
  "
              dangerouslySetInnerHTML={{
                __html: processContent(data.bloque13),
              }}
            />
          </div>
        </div>
        {/*Direcciones Generales */}
        <div>
          <div
            className="text-center max-w-6xl m-auto px-6 sm:px-0 "
            dangerouslySetInnerHTML={{
              __html: data.bloque14,
            }}
          />
          <div className="max-w-6xl mx-auto px-6 sm:px-0 pb-10">
            <div
              className="
    grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8
    
    /* ESTILOS DE CARD PARA CADA DIV HIJO */
    [&>div]:bg-white 
    [&>div]:rounded-2xl 
    [&>div]:p-4 
    [&>div]:shadow-md 
    [&>div]:border 
    [&>div]:border-gray-100 
    [&>div]:transition-all 
    [&>div]:duration-300 
    [&>div]:flex 
    [&>div]:flex-col 
    [&>div]:items-center 
    [&>div]:text-center
    [&>div]:relative
    [&>div]:overflow-hidden    
    /* ESTILOS DE IMAGEN DENTRO DE LA CARD */
    [&>div_img]:object-cover 
      [&>div_img]:w-24   
       [&>div_img]:h-24
        [&>div_img]:mb-6
    [&>div_img]:shadow-sm
      [&_p]:text-sm
        [&_p]:leading-base
           [&_p]:p-0
    
  "
              dangerouslySetInnerHTML={{
                __html: processContent(data.bloque15),
              }}
            />
          </div>
        </div>
      </section>

      {/*Unidades de apoyo rectoral */}
      <section>
        <div
          className="text-center max-w-6xl m-auto px-6 sm:px-0 mt-10"
          dangerouslySetInnerHTML={{
            __html: data.bloque16,
          }}
        />
        <div className="max-w-6xl mx-auto px-6 sm:px-0 pb-10">
          <div
            className="
    grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 link-1 
    
    /* ESTILOS DE CARD PARA CADA DIV HIJO */
    [&>div]:bg-white 
    [&>div]:rounded-2xl 
    [&>div]:p-4 
    [&>div]:shadow-md 
    [&>div]:border 
    [&>div]:border-gray-100 
    [&>div]:transition-all 
    [&>div]:duration-300 
    [&>div]:flex 
    [&>div]:flex-col 
    [&>div]:items-center 
    [&>div]:text-center
    [&>div]:relative
    [&>div]:overflow-hidden    
    /* ESTILOS DE IMAGEN DENTRO DE LA CARD */
    [&>div_img]:object-cover 
      [&>div_img]:w-24   
       [&>div_img]:h-24
        [&>div_img]:mb-6
    [&>div_img]:shadow-sm
      [&_p]:text-sm
        [&_p]:leading-base
           [&_p]:p-0
    
  "
            dangerouslySetInnerHTML={{
              __html: processContent(data.bloque17),
            }}
          />
        </div>
      </section>

      {/*Asociaciones*/}
      <div>
        <div className="text-center max-w-6xl m-auto px-6 sm:px-0 ">
          <h3>Asociaciones y federaciones</h3>
        </div>
        <div className="max-w-6xl mx-auto px-6 sm:px-0 pb-10">
          <div
            className=" link-1 [&_a]:mt-4
    grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8
    
    /* ESTILOS DE CARD PARA CADA DIV HIJO */
    [&>div]:bg-white 
    [&>div]:rounded-2xl 
    [&>div]:p-4 
    [&>div]:shadow-md 
    [&>div]:border 
    [&>div]:border-gray-100 
    [&>div]:transition-all 
    [&>div]:duration-300 
    [&>div]:flex 
    [&>div]:flex-col 
    [&>div]:items-center 
    [&>div]:text-center
    [&>div]:relative
    [&>div]:overflow-hidden    
    /* ESTILOS DE IMAGEN DENTRO DE LA CARD */
    [&>div_img]:object-cover 
      [&>div_img]:w-24   
       [&>div_img]:h-24
        [&>div_img]:mb-6
    [&>div_img]:shadow-sm
      [&_p]:text-sm
        [&_p]:leading-base
           [&_p]:p-0
  "
            dangerouslySetInnerHTML={{
              __html: processContent(data.bloque18),
            }}
          />
        </div>
      </div>

      {/*decanos*/}
      <section className="py-20 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Encabezado con mejor tipografía */}
          <div className="text-center  ">
            <h3>Autoridades académicas</h3>
          </div>

          {/* Grilla responsiva de autoridades */}
          <div className="grid grid-cols-1 sm:grid-cols-4 md:grid-cols-4 gap-8">
            {[
              { card: data.bloque19, modal: data.bloque20 },
              { card: data.bloque21, modal: data.bloque22 },
              { card: data.bloque23, modal: data.bloque24 },
              { card: data.bloque25, modal: data.bloque26 },
              { card: data.bloque27, modal: data.bloque28 },
              { card: data.bloque29, modal: data.bloque30 },
              { card: data.bloque31, modal: data.bloque32 },
              { card: data.bloque33, modal: data.bloque34 },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center transition-all hover:shadow-md
                     [&_img]:w-64 [&_img]:h-64 [&_img]:mb-5 [&_img]:aspect-square [&_img]:object-cover [&_img]:object-top [&_img]:rounded-xl [&_img]:shadow-sm
                     
      [&_p]:leading-base  [&_p]:p-0   "
              >
                {/* Contenido de la tarjeta principal */}
                <div
                  className="w-full flex flex-col items-center"
                  dangerouslySetInnerHTML={{
                    __html: processContent(item.card),
                  }}
                />

                <div className="mt-6">
                  <Modal
                    title="Autoridades facultad"
                    content={
                      <div
                        className=" bg-white p-10 [&_img]:w-48 [&_img]:h-48 [&_img]:aspect-square [&_img]:object-cover [&_img]:object-top  [&_img]:rounded-lg mx-auto"
                        dangerouslySetInnerHTML={{
                          __html: processContent(item.modal),
                        }}
                      />
                    }
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => (
        <AnimatePresence mode="wait">
          <DataDisplay key="data-loaded" data={data} />
        </AnimatePresence>
      )}
    </DataFetcherTemplateHome2>
  );
}
